// permet d'appeler des fonctions directement dans les componsants sans faire d'import de fichier.
// ces composants sont appelés this this.xxxx
// exemple : this.$api.get ...

import store from "../store/store";
import moment from "moment";
import router, { resetRouter } from "./customRouter.js";
import main from "../components/main/templates/mainTemplate";
import localization from 'moment/locale/fr';


import textfield from '../components/fields/textfield'
import conversion from '../components/fields/conversion'
import select from '../components/fields/select'
import radio from '../components/fields/radio'
import SwitchC from '../components/fields/switch'
import colorpicker from '../components/fields/colorPicker'
import arraytable from '../components/fields/arrayTable'
import autocomplete from '../components/fields/autocomplete'
import datepicker from '../components/fields/datePicker'
import datetimepicker from '../components/fields/dateTimePicker'
import timeonlypicker from '../components/fields/timeOnlyPicker'
import datetimeselect from '../components/fields/dateTimeSelect'
import textarea from '../components/fields/textarea'
import fileinput from '../components/fields/fileInput'
import texteditor from '../components/fields/texteditor'
import encartphoto from '../components/fields/encartPhoto'
import fieldrecurr from '../components/fields/FieldRecurr'
import optionscreator from '../components/fields/optionsCreator'
import optionsreceptor from '../components/fields/optionsReceptor'
import abaque from '../components/fields/Abaque'
//créer dans vuex pour stocker les variables dures de l'utilisateur
import environnement from './environnement'

import { EventBus } from './EventBus.js';



function randomKey(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const functions = {
    install(Vue) {
        Vue.prototype.randomKey = randomKey

        // Les critères sont résolus au clic, dans le contexte de la ligne et de sa page.
        Vue.prototype.resolveActiveTabRequests = (requests, context = {}) => {
            if (!Array.isArray(requests)) return []
            return requests.filter(request => request && typeof request === 'object').map(request => {
                const criteria = request.params && typeof request.params === 'object' && !Array.isArray(request.params)
                    ? request.params : {}
                const params = Object.fromEntries(Object.entries(criteria).map(([key, value]) => {
                    if (typeof value !== 'string') return [key, value]
                    const variable = value.match(/^\[\[table\|\|([^\]]+)\]\]$/)
                    if (variable) {
                        const resolved = variable[1].split(' ').filter(Boolean).reduce((current, part) => (
                            current !== null && typeof current === 'object' && Object.prototype.hasOwnProperty.call(current, part)
                                ? current[part] : undefined
                        ), context.line)
                        return [key, resolved === undefined || resolved === null ? '' : resolved]
                    }
                    return [key, Vue.prototype.replaceBy({ text: value, page: context.page, line: context.line })]
                }))
                return { moduleid: request.moduleid, tabid: request.tabid, params }
            })
        }

        // La référence emprunte les paramètres existants ; seule la liste reste dans Vuex.
        Vue.prototype.prepareActiveTabNavigation = (navigation, destination = {}) => {
            const params = { ...(navigation.replace || {}) }
            const pending = store.getters.pendingActiveTabs
            if (navigation._activeTabsPrepared && (
                params.__activeTabsNavigation ? pending?.token === params.__activeTabsNavigation : !pending
            )) return { ...navigation, replace: params }

            delete params.__activeTabsNavigation
            const requests = Array.isArray(navigation.setactivtab) ? navigation.setactivtab : []
            const token = requests.length ? `tabs-${Date.now()}-${randomKey(12)}` : null
            store.dispatch('replacePendingActiveTabs', { token, targetPath: destination.path || '', requests })
            if (token && store.getters.pendingActiveTabs?.token === token) params.__activeTabsNavigation = token
            return { ...navigation, replace: params, _activeTabsPrepared: true }
        }

        Vue.prototype.moment = (date) => {
            moment.locale('fr', localization)
            return moment(date)
        }

        Vue.prototype.$env = environnement


        Vue.prototype.sendInRoute = (element) => {

            let rout = {
                path: element.url,
                component: main,
                meta: {},
                name: element.name,
                children: [],
                engine: element.engine,
                table: element.table,
                parentform: element.parentform,
                params: element.displays.params,
                displayname: element.displays.displayname,
                // obligatoire pour l'envoi dans le component
                props: {
                    page: element.id,
                    typeform: element.typeform,
                },
                //props: (route) => ({ page: element.id, type: element.type, get: route.query }),
            };
            router.addRoute(rout);
            let forVuex = {
                path: element.url,
                name: element.name,
                displayname: element.displays.displayname,
                typeform: element.typeform,
                props: rout.props,
                parentform: element.parentform
            }
            store.dispatch("pushAll", forVuex);
        }

        Vue.prototype.getAllPages = () => {
            return new Promise((resolve) => {
                store.dispatch('removeAllPages')
                resetRouter();
                Vue.prototype.API({ type: 'get', url: 'allpage' }).then((resp) => {
                    resp.data.forEach((element) => {

                        Vue.prototype.sendInRoute(element)

                        if (element.children && element.children.length > 0) {

                            element.children.forEach((child) => {

                                Vue.prototype.sendInRoute(child)

                            })
                        }

                        resolve(true);
                    });
                });
            });
        };

        // permet de spliter l'url de base(client/:id) et de le remplacer par l'id que l'on a placé dans dans l'élément replace de la fonction gotTo
        Vue.prototype.newurl = (elem) => {
            // on recherche la page avec l'id en question
            let targetPage = JSON.parse(JSON.stringify(store.getters["listAll"]))

            targetPage = targetPage.find(
                (el) => {
                    return (
                            (el.props.page !== undefined && el.props.page === elem.page) ||
                            (elem.name !== undefined && el.name === elem.name) ||
                            (elem.url !== undefined && el.path === elem.url)
                        ) &&
                        (elem.typeform === undefined || el.props.typeform === elem.typeform)
                }
            ) || false;
            if (targetPage) {
                var ret = '';
                switch (elem.returnElement) {
                    case 'url':
                        ret = targetPage.path.replace(/:([^/]+)/g, (_, key) => elem.replace[key])
                        break;
                    case 'all':
                        targetPage.originalPath = targetPage.path
                        targetPage.path = targetPage.path.replace(/:([^/]+)/g, (_, key) => elem.replace[key])
                        ret = targetPage;
                        break;
                    default:
                        ret = targetPage.path.replace(/:([^/]+)/g, (_, key) => elem.replace[key])
                }
                return ret;

            } else { return false; }

        };


        // raccourcie pour appeler une page ( soit en modal, soit en page centrale)
        // variables pour elements :
        // page : id de la page qui va etre appelé - (numerique)
        // replace : arguments de l'url, exemple : {id: [id_du_client]} - (array)
        // type : modal ou center - (string)
        // paramDialog : paramètres du modal, voir dans templates - modalTemplate avec la var paramDialog - (array)
        Vue.prototype.goTo = (elements) => {
            elements.returnElement = 'all'
            var newurl = Vue.prototype.newurl(elements);
            // on check si les params sont bien définis, sinon on arrete l'envoi de le page
            if (!newurl.path) {
                Vue.$toast.error('Paramètres manquants, vous ne pouvez pas accéder à cette page', { position: "top-right", timeout: 3000 });
                return false;
            }

            //si on veut juste appliquer une query sans faire appel a la page.
            if (elements.query && elements.reload) {
                if (!elements.modal) {
                    router.replace({ query: elements.query });
                } else {
                    
                    store.dispatch('changeOptionsModal', { modal: { type: 'to', val: elements.page }, type: 'query', value: elements.query });
                }
                return
            }

            if (!['modal', 'center'].includes(elements.type)) {
                alert("mauvais parametrage de direction : aucun type d'ouverture selectionné")
                return false
            }
            elements = Vue.prototype.prepareActiveTabNavigation(elements, newurl)

            if (elements.type == "modal") {

                store.dispatch("showModal", {
                    newurl: newurl.path,
                    propsPage: newurl,
                    current: elements.modalKey,
                    params: elements.replace,
                    query: elements.query,
                    paramDialog: elements.paramDialog,
                });
            var query = {...router.currentRoute.query, ...elements.query} 
            if(elements.query) router.push({ query: query }).catch(() => {});
            } else if (elements.type == "center") {
                // Une action sur la page courante peut aussi changer uniquement son onglet.
                if (router.currentRoute.path === newurl.path) {
                    const contextKey = store.getters.currentPage
                    const context = store.getters.specificPage(contextKey)
                    if (context && Number(context.idpage) === Number(newurl.props.page)) {
                        const params = { ...context.params, ...elements.replace }
                        delete params.__activeTabsNavigation
                        if (elements.replace.__activeTabsNavigation) params.__activeTabsNavigation = elements.replace.__activeTabsNavigation
                        store.dispatch('changeParamPage', { page: contextKey, item: 'params', value: params })
                    }
                }
                return router.push({ name: newurl.name, params: elements.replace, query: elements.query }).catch(error => {
                    if (error.name !== 'NavigationDuplicated' && store.getters.pendingActiveTabs?.token === elements.replace.__activeTabsNavigation) {
                        store.dispatch('reconcilePendingActiveTabsNavigation', { token: null })
                    }
                    return false
                })
            }
        };


        // envoie vers l'api en intégrant le queue
        Vue.prototype.API = (elements) => {
            if(!elements.url) {
                console.log('manquant ',elements);
                return;
            }
            var params = (!elements.params) ? {} : elements.params;
            // La référence d'ouverture reste locale au navigateur, hors des paramètres métier.
            const hasNavigationToken = value => value && Object.prototype.toString.call(value) === '[object Object]'
                && Object.prototype.hasOwnProperty.call(value, '__activeTabsNavigation')
            if (hasNavigationToken(params) || hasNavigationToken(params?.params)) {
                params = { ...params }
                delete params.__activeTabsNavigation
                if (hasNavigationToken(params.params)) {
                    params.params = { ...params.params }
                    delete params.params.__activeTabsNavigation
                }
            }
            return store.dispatch("callAxios", { token: Vue.prototype.randomKey(6), type: elements.type, url: elements.url, params: params, apidefault: elements.apidefault });
        }

        Vue.prototype.checkScenario = (elements) => {

            return new Promise((resolve, reject) => {
                let getResponseKey = (!elements.getResponseKey) ? {} : elements.getResponseKey;
                let el = elements.ventilation[elements.row];
                let fields = (elements.fields) ? elements.fields : [];
                //on récupère les lignes de before et after, ainsi que les potentielles insertions et requetes simple pour lesrelancer ds la backe et les utiliser
                getResponseKey['lines'] = el.result.lines;
                var wait = false;
                var stop = false;
                //chaque returnfront représente une action a envoyé dans le front pour une ventilation
                if (el && el.result) el.result.returnfront.forEach((returnFront) => {
                    if (!wait) {
                        switch (returnFront.type) {
                            case 'ifconfirm':

                                //le setTimeout pour juste laisser le temps à des refresh de module ou autre (en meme temps que le ifconfirm se lance)

                                if (confirm(returnFront.text)) {
                                    getResponseKey[returnFront.key] = false
                                    Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: el.id, params: el.params, response: getResponseKey, page: el.page, fields: fields } }).then((resp) => {
                                        elements.ventilation[elements.row].result = resp.data.result
                                        resolve(Vue.prototype.checkScenario({ ventilation: elements.ventilation, page: elements.page, modalKey:elements.modalKey, getResponseKey: getResponseKey, row: elements.row, fields: fields, runAfterEnd : elements.runAfterEnd ?? false }))

                                    })
                                } else {
                                    getResponseKey[returnFront.key] = true
                                    Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: el.id, params: el.params, response: getResponseKey, page: el.page, fields: fields } }).then((resp) => {
                                        elements.ventilation[elements.row].result = resp.data.result
                                        resolve(Vue.prototype.checkScenario({ ventilation: elements.ventilation, page: elements.page, modalKey:elements.modalKey, getResponseKey: getResponseKey, row: elements.row, fields: fields, runAfterEnd : elements.runAfterEnd ?? false }))

                                    })
                                }

                                wait = true
                                break;

                            case 'chooseuser':


                                getResponseKey[returnFront.key] = true
                                EventBus.$emit('sendDatas', { template: returnFront.template,title:returnFront.title, crochet: '', page: elements.modalKey });

                                EventBus.$on('send-data', (data) => {
                                    EventBus.$off('send-data');
                                    getResponseKey['lines'][returnFront.choicekey] = data;
                                    Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: el.id, params: el.params, response: getResponseKey, page: el.page, fields: fields } }).then((resp) => {
                                        elements.ventilation[elements.row].result = resp.data.result
                                        resolve(Vue.prototype.checkScenario({ ventilation: elements.ventilation, page: elements.page ,modalKey:elements.modalKey, getResponseKey: getResponseKey, row: elements.row, fields: fields,runAfterEnd : elements.runAfterEnd ?? false }))

                                    })
                                });
                                wait = true;
                                break;
                            case 'alert':

                                Vue.$toast[returnFront.state](returnFront.text,{timeout: 800 });

                                break;

                                //permet de renvoyer le fait que la requete a bein été effectué, elle ne se lancera plus par la suite.

                            case 'stop':

                                reject();
                                stop = true;
                                break;

                            case 'overlay':
                                getResponseKey[returnFront.key] = true
                                store.dispatch('textOverlay', returnFront.text)
                                store.dispatch('getoverlay', returnFront.isopen);

                                Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: el.id, params: el.params, response: getResponseKey, page: el.page, fields: fields } }).then((resp) => {
                                    elements.ventilation[elements.row].result = resp.data.result
                                    resolve(Vue.prototype.checkScenario({ ventilation: elements.ventilation, page: elements.page,modalKey:elements.modalKey , getResponseKey: getResponseKey, row: elements.row, fields: fields, runAfterEnd : elements.runAfterEnd ?? false }))

                                })
                                wait = true;


                                break;

                            case 'reloadmodule':
                                store.dispatch('addReloadModule', { modules: returnFront.module })
                                break;

                            case 'closecurrmodal': {
                                const currentPage = store.getters.modalShowParams({
                                    type: 'current',
                                    val: elements.modalKey
                                })
                                const modalKeyToClose = currentPage?.parent || elements.modalKey

                                store.dispatch('closeModal', { modalKey: modalKeyToClose })
                                break;
                            }

                            case 'loadmodule':
                                getResponseKey[returnFront.key] = true
                                if(returnFront.module.type=='ventilation') {

                                    

                                    let newParams = {params:{},querys:{}};
                                    returnFront.datas.forEach((data) => {
                                        switch(data.typevar) {
                                            case 'params' : 
                                            newParams.params[data.key] = data.value 
                                            break;
                                            case 'query' : 
                                            newParams.querys[data.key] = data.value 
                                            break;
                                        }
                                        
                                    })                            
                                    //runAfterEnd : permet de continuer le précédent checkscenario si d'autre éléments sont encore à traiter dans la boucle        
                                        Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: returnFront.module.id, params: newParams.params ,page: elements.page } }).then((resp) => {
                                            let newVentil = [{id: returnFront.module.id, params: newParams.params, page: elements.page, result:resp.data.result}];
                                            resolve(Vue.prototype.checkScenario({ ventilation: newVentil, page: elements.page, modalKey:elements.modalKey, row: 0, fields: fields, 
                                                getResponseKey: {},
                                                
                                                runAfterEnd : { el: el , getResponseKey: getResponseKey, row: elements.row, fields: fields, page: elements.page, modalKey: elements.modalKey, next: elements.runAfterEnd || false }
                                           
                                            }))
                                        })                            
                                wait = true;
                                } else {
                                    store.dispatch('addVentilation', { type: 'loadmodule', module: returnFront.module, crochet: returnFront.crochet, datas: returnFront.datas, page: elements.modalKey })
                                }
                                
                                break;

                            case 'loadpage':
                                store.dispatch('addVentilation', { type: 'loadpage', pageloaded: returnFront.page, crochet: returnFront.crochet, modeopen: returnFront.modeopen, datas: returnFront.datas, page: elements.modalKey })
                                break;

                            case 'changestore':
                                returnFront.fields.forEach((field) => {

                                    store.dispatch('pushForm', { page: elements.modalKey, value: field.value, champ: field.field })
                                })

                            break;

                            case 'reloaddataform':
                                //si les champs à updater proviennent du formulaire en cours d'utilisation, on les rechargent :
                                if(returnFront.fields.length) {

                                    var page = store.getters.specificPage(elements.modalKey);
                                    Vue.prototype.initForm({modalKey:elements.modalKey,params:page['params'],typeform:page['props']['typeform'],page:elements.page}).then(()=>{
                                        store.dispatch('setReloadForms',{ modalKey:elements.modalKey,fields:returnFront.fields });
                                        setTimeout(()=> {
                                            store.dispatch('removeReloadForms',{modalKey:elements.modalKey})
                                        },1000)
                                    }) 
                                }
                                //si c'est un champ exterieur, on va chercher ou se situe ce champ dans un form et on va l'updater
                                if(returnFront.otherfields!='') {
                                    //1-on cherche ou se trouve ces champs
                                    var others = returnFront.otherfields.split(',')
                                    others.forEach((field) => {
                                        store.getters.allListForm.forEach((form) => {
                                            if(field in form.fields) {
                                                console.log('trouvé dans  ',form.page)
                                                var getModalKey = form.page
                                                //on récupère les params pour réinitialiser le form
                                                var page = store.getters.specificPage(getModalKey);
                                                Vue.prototype.initForm({modalKey:getModalKey,params:page['params'],typeform:page['props']['typeform'],page:page['idpage']}).then(()=>{
                                                    store.dispatch('setReloadForms',{ modalKey:getModalKey,fields:[field] });
                                                    setTimeout(()=> {
                                                        store.dispatch('removeReloadForms',{modalKey:elements.modalKey})
                                                    },1000)
                                                })                                                
                                            }
                                        })
                                    })
                                }

                            break;

                            default:
                                //permet de renvoyer le fait que la requete a bein été effectué, elle ne se lancera plus par la suite.
                                getResponseKey[returnFront.key] = returnFront.type;

                        }
                    }

                })

                if (stop) {
                    reject();
                    return;
                } else {
                    if (!wait) {

                        if (elements.ventilation[elements.row + 1]) {

                            resolve(Vue.prototype.checkScenario({ ventilation: elements.ventilation, page: elements.page, modalKey:elements.modalKey, getResponseKey: {}, row: elements.row + 1, fields: fields, runAfterEnd : elements.runAfterEnd ?? false }))
                        } else {

                            if(elements.runAfterEnd) {
                                store.dispatch('textOverlay', 'Veuillez patienter')
                                store.dispatch('getoverlay', true)
                                let rae = elements.runAfterEnd;
                                Vue.prototype.API({ type: 'post', url: 'displaymodule', params: { id: rae.el.id, params: rae.el.params, response: rae.getResponseKey, page: rae.page, fields: rae.fields } }).then((resp) => {
                                    store.dispatch('getoverlay', false)
                                    let newEl = [{id: rae.el.id, params: rae.el.params, page: rae.page, result : resp.data.result}]                                    
                                    //console.log('on run after end',{ ventilation: newEl, page: elements.page,modalKey:elements.modalKey , getResponseKey: getResponseKey, row: elements.row, fields: fields })                                    
                                    resolve(Vue.prototype.checkScenario({ ventilation: newEl, page: rae.page, modalKey:rae.modalKey , getResponseKey: rae.getResponseKey, row: 0, fields: rae.fields, runAfterEnd: rae.next || false }))

                                })
                            } else {
                                resolve();
                            }

                            
                        }
                    }
                }

            });

        }





        Vue.prototype.validateForm = (elements) => {
            //action de validation du formulaire
            // on va chercher la modal parente qui montre si c'est ouvert ou pas (car la modal actuelle est celle de la page en cours qui peut montrer autre chose)
            let parentModal =  store.getters.modalShowParams({ type: "current", val: elements.modalKey })?.['parent']
            let modal = store.getters.modalShowParams({ type: "current", val: parentModal });
            //récup des éléments du form
            let elemForm = store.getters.listForm(elements.modalKey)


            // on récupère l'url pour le lancement du put vers l'API (l'url du formulaire est similaire à l'url de modification du form)
                //si ca vient d'un formulaire indépendant :
            let urlSend = (elemForm) ? elemForm.url : (elements.url) ? elements.url : false;

            if(!urlSend) {
                elements.ifNotValid("URL manquante")
                return;
            }
            store.dispatch('getoverlay', true)

            if (!elements.form || !elements.form.validate()) {
                store.dispatch('getoverlay', false)
                elements.ifNotValid()
                return;
            }
                // validation du formulaire  

                // on récupère le type d'enregistrement :
                let getTypeValidate = (!elements.validate && elemForm) ? elemForm.validate : elements.validate;

                // permet de cibler les champs qui sont updatés : soit les champs classiques via le store, 
                //soit les champs issues d'un form indépendant (via le FormModule)
                let valFields = (!elements.fields) ? elemForm.fields : elements.fields;

                // Transmet le contexte de la fiche aux ventilations sans le mêler aux champs.
                const pageParams = store.getters.specificPage(elements.modalKey)?.params;
                const contextParams = elements.params ?? elemForm?.params ?? pageParams ?? {};
                const params = contextParams && typeof contextParams === 'object' && !Array.isArray(contextParams)
                    ? { ...contextParams }
                    : {};


                //première étape, envoi pour vérification des ventilations :
                //Lancement des ventilations pour vérification avant enregistrement. 
                //console.log(valFields)

                //début d'enregistrement du formulaire
                Vue.prototype.API({ type: 'put', url: urlSend, params: { fields: valFields, ventilation: elements.ventilation, params: params } }).then((resp) => {

                        store.dispatch('getoverlay', false)

                        if (resp.data.success) {
                            //si l'enregistrement détecte des ventilations avant l'action, la function ventil prend la relève. dès que cette function est trerminé et retourne true, 
                            // on repart sur un nouvel enregistrement, en mettant une var dans l'url pour ne plus lancer les ventils. 
                            if (resp.data.ventilation && resp.data.ventilation.before) {
                                store.dispatch('getoverlay', true)
                                Vue.prototype.checkScenario({ ventilation: resp.data.ventilation.before,modalKey:elements.modalKey, page: elements.page, row: 0, fields: valFields }).then(() => {
                                    store.dispatch('getoverlay', false);
                                    elements.ventilation = true;

                                    return Vue.prototype.validateForm(elements)
                                }).catch(() => {
                                    store.dispatch('getoverlay', false);
                                    elements.ifNotValid("erreur sur retour scenario");
                                    return false;
                                })
                                return;
                            }

                            if (resp.data.isStored) Vue.$toast.success('enregistré', { position: "bottom-right", timeout: 2000 });

                            //permet de stocker la dernière insertion ou le dernier update
                            store.dispatch('setLastStored', resp.data.args);
                            //si l'enreg est en mode classique
                            if (!elements.fields) {
                                //si c'est un enregistrement frais
                                if (resp.data.new) {

                                    // si c'est une modal
                                    if (modal && modal.show == true) {

                                        switch (getTypeValidate) {

                                            case 1:
                                                //validation qui entraine directement vers le mode édition de cette ligne

                                                //1 on change dans les params le id=new par id=nouvel id de la ligne
                                                elemForm.params.id = resp.data.args.id
                                                elemForm.typeform = 'edit'
                                                    //1 - on change l'url de destination pour mettre la nouvelle                                   
                                                    // si c'est une modal est que l'enregistrement se fait sur un enfant, il faut aussi mettre à jour idparent
                                                    //store.dispatch('changeParamForm', { page: elements.page, type: 'params', value: resp.data.args });                                              
                                                urlSend = Vue.prototype.newurl({ name: resp.data.redirect, replace: elemForm.params });
                                                elemForm.url = urlSend
                                                modal.params = elemForm.params
                                                modal.propsPage.name = resp.data.redirect
                                                modal.propsPage.path = urlSend
                                                modal.propsPage.url = urlSend
                                                store.dispatch('changeParamPage', { page: elements.modalKey, item: 'params', value: elemForm.params })
                                                store.dispatch('changeParamForm',{page:elements.modalKey,type:'validate',value:0})
                                                break;

                                            case 2:
                                                //validation qui entraine un nouveau formulaire
                                                //appel de l'api pour récupérer les valeurs des champs
                                                // les params permettent de récupérer des POST à envoyer dans l'API afin de préremplir les champs l'ors de l'insert
                                                Vue.prototype.API({ type: 'get', url: urlSend, params: elemForm.params }).then((resp) => {
                                                    // on réinitialise le store du formulaire
                                                    store.dispatch('initForm', { page: elements.modalKey, valid: true });
                                                    for (const array in resp.data.valFields) {
                                                        store.dispatch('pushForm', { page: elements.modalKey, champ: array, value: resp.data.valFields[array] });
                                                    }

                                                })
                                                store.dispatch('changeParamForm',{page:elements.modalKey,type:'validate',value:0})
                                                break;

                                            case 3:
                                                //validation qui ferme de suite la modale apres
                                                store.dispatch('closeModal', { modalKey: parentModal })
                                                break;
                                        }

                                    } else {
                                        //si enreg frais et pas modal
                                        switch (getTypeValidate) {

                                            case 1:
                                                //validation qui entraine directement vers le mode édition de cette ligne
                                                Vue.prototype.goTo({ modalKey: elements.modalKey, name: resp.data.redirect, type: 'center', replace: resp.data.args })
                                                break;

                                            case 2:
                                                //validation qui entraine un nouveau formulaire
                                                router.go()
                                                break;

                                            case 3:
                                                //validation qui ferme de suite la modale apres
                                                //si ca ferme automatiquement, on reviens à le précédente page
                                                router.go(-1)
                                                break;
                                        }
                                        // si c'est une page centrale, et nouveau form on rafraichi tout simplement


                                    }

                                } else {
                                    // si la validation entraine la fermeture automatique
                                    if (getTypeValidate == 3) {
                                        if (modal && modal.show == true && elements.hook!='fromtable') {
                                            //en cas de modal
                                            store.dispatch('closeModal', { modalKey: parentModal })
                                        } else if(!modal && elements.hook!='fromtable') {
                                            //en cas formulaire en centre
                                            router.go(1)

                                        } else if(elements.hook=='fromtable') {
                                            //en cas form à partir d'une table
                                            console.log('validate',getTypeValidate,' en fromtable')
                                            EventBus.$emit('closeFromTable', { page: elements.page });
                                        }

                                    }

                                }


                            } // fin enreg en mode classique (via le store). si on veut rajouter des actions après enreg en mode indépendant,
                            // mettre un else à  ce niveau la 

                            //lancement des ventilations (si il y a) après enregistrement 
                            if (resp.data.ventilation && resp.data.ventilation.after) {
                                Vue.prototype.checkScenario({ ventilation: resp.data.ventilation.after, page: elements.page, modalKey:elements.modalKey, row: 0, fields: valFields }).catch(() => {})
                            }

                            elements.callback(resp.data);

                        } else {
                            Vue.$toast.error(resp.data.message, { position: "bottom-right", timeout: 2000 });
                            elements.ifNotValid(resp.data.message)
                        }

                    })
                    //fin d'enregistrement du formulaire


        }



        Vue.prototype.initForm = (elements) => {
            //elements :
            //page : id de la page
            //params : params de la page en cours
            //typeform: 'new' ou 'edit' selon si nouveau form ou form en update
            //modalKey : la clé de la page en cours
            return new Promise((resolve, reject) => {

            let urlForm = Vue.prototype.newurl({page:elements.page,replace:elements.params,typeform:elements.typeform})
        
                  Vue.prototype.API({type:'get',url:urlForm,params:elements.params}).then((resp)=> {

                        if(!resp.data.success) {
                            resolve(resp.data);
                            return;
                        }
                      store.dispatch('initForm', { page:elements.modalKey,valid:true,typeform: elements.typeform,params:elements.params,url:urlForm});
                      
                      for(const array in resp.data.valFields) {
                          
                          store.dispatch('pushForm', { page:elements.modalKey, champ:array,value: resp.data.valFields[array]});
                      } 

                      resolve(resp.data)
                  }).catch(reject)
            })    
        }

        Vue.prototype.clickActions = (elements) => {
            // args : éléments de la ligne sélectionné provenants de la base, envoyé par le module.
            // action : array du l'action comportant les arguments de l'action
            //idmodule : id du module ou se trouve l'action
            //page : la page d'ou vient l'action
            //multipleLines : si c'est du module table, cela peut interagir avec plusieurs lignes. dans ce cas c'est true
            var params = {}
            var query = {}
            if (elements.action.typelink == 'link' || elements.action.typelink == 'api') {
                const pageContext = elements.modalKey || elements.page;
                elements.action.get.forEach((v) => {

                    if (v.typedata == 'array') {
                        params[v.key] = {} 
                        //dans le cas ou la valeur est un string, on va le convertir en array
                        if (typeof v.value == 'string') {
                        v.value = Vue.prototype.replaceBy({ text: v.value, page: pageContext });
                        v.value = JSON.parse(v.value)
                        }
                        v.value.forEach((av) => {
                            params[v.key][av.key] = Vue.prototype.replaceBy({ text: av.value, page: pageContext });
                            if (av.type == 'table') params[v.key][av.key] = elements.args[av.value]
                        })
                    } else {
                        if (v.typevar == "query") {
                            query[v.key] = Vue.prototype.replaceBy({ text: v.value, page: pageContext });
                            if (v.type == 'table') query[v.key] = elements.args[v.value]
                        } else {
                            params[v.key] = Vue.prototype.replaceBy({ text: v.value, page: pageContext });
                            if (v.type == 'table') params[v.key] = elements.args[v.value]
                        }
                    }

                })

            }

            if (elements.action.typelink == 'link') {
                const setactivtab = Vue.prototype.resolveActiveTabRequests(elements.action.params?.setactivtab, {
                    page: elements.modalKey || elements.page, line: elements.args,
                })
                const navigation = { modalKey: elements.modalKey, name: elements.action.page_name, type: elements.action.target, replace: params, query: query, paramDialog: elements.action.paramdialog, setactivtab }
                if (typeof elements.navigate === 'function') {
                    const destination = Vue.prototype.newurl({ ...navigation, returnElement: 'all' }) || {}
                    elements.navigate(Vue.prototype.prepareActiveTabNavigation(navigation, destination))
                }
                else Vue.prototype.goTo(navigation)
                if (elements.whenlink) elements.whenlink()
            }

            if (elements.action.typelink == 'api') {
                let act = elements.action.params
                params['action'] = elements.action.id;
                
                params['line'] = elements.args;
                //si c'est plusieurs lignes selectionnées, on place selected dans le back avec comme array, toutes les lignes
                params['selected'] = elements.multipleLines                   

                if ((act.ifconfirm && act.ifconfirm != '' && confirm(act.ifconfirm)) || (!act.ifconfirm || act.ifconfirm == '')) {
                    store.dispatch('textOverlay', 'Action en cours')
                    store.dispatch('getoverlay', true);
                    Vue.prototype.API({ type: act.apilink.type, url: Vue.prototype.replaceBy({ text: act.apilink.url, page: elements.page, line: elements.args }), params: params }).then((resp) => {
                    store.dispatch('getoverlay', false);    
                        if (resp.data.ventilation) {
                            // si il ya une ventil avant modif d'un champ
                            if (resp.data.ventilation.before) {
                                Vue.prototype.checkScenario({ ventilation: resp.data.ventilation.before, page: elements.page, modalKey:elements.modalKey , row: 0 }).then(() => {

                                    }).catch(() => {
                                        return;
                                    })
                                    // si il ya une ventil après modif d'un champ
                            } else if (resp.data.ventilation.after) {
                                Vue.prototype.checkScenario({ ventilation: resp.data.ventilation.after, page: elements.page, modalKey:elements.modalKey, row: 0 })
                            } else {
                                // si on appelle directement un module de ventilation
                                Vue.prototype.checkScenario({ ventilation: [resp.data], page: elements.page, modalKey:elements.modalKey , row: 0 }).catch(() => { return; })
                            }

                        }

                        if (resp.data.success) {
                            elements.success(resp.data)
                        } else {
                            if (resp.data.message) Vue.$toast.error(resp.data.message);
                        }
                    });

                }

            }

            if (elements.action.typelink == 'href') {
                if (Vue.prototype.replaceBy({ text: elements.action.params.apilink.url, page: elements.page, line: elements.args }) &&
                    Vue.prototype.replaceBy({ text: elements.action.params.apilink.url, page: elements.page, line: elements.args }) != 'null') {
                    window.open(Vue.prototype.replaceBy({ text: elements.action.params.apilink.url, page: elements.page, line: elements.args }), '_blank');
                } else {
                    Vue.$toast.error('Lien non inséré')
                }

            }

        }


        const parseNumericValueForFormat = (input) => {
            if (input === null || typeof input === 'undefined') return NaN;
            if (typeof input === 'number' && Number.isFinite(input)) return input;
            const stringValue = String(input).trim();
            if (!stringValue) return NaN;
            let normalized = stringValue.replace(/[\s\u00A0\u202F]/g, '');
            const commaMatches = normalized.match(/,/g) || [];
            const dotMatches = normalized.match(/\./g) || [];
            const hasComma = commaMatches.length > 0;
            const hasDot = dotMatches.length > 0;

            if (hasComma && hasDot) {
                if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
                    normalized = normalized.replace(/\./g, '').replace(/,/g, '.');
                } else {
                    normalized = normalized.replace(/,/g, '');
                }
            } else if (hasComma) {
                normalized = normalized.replace(/,/g, '.');
            } else if (dotMatches.length > 1) {
                normalized = normalized.replace(/\./g, '');
            }

            const numericValue = Number(normalized);
            return Number.isFinite(numericValue) ? numericValue : NaN;
        };

        Vue.prototype.formatOutput = ({ value, format }) => {
            if (!format) return value;
            const formatToken = String(format).trim();
            if (!formatToken) return value;
            const splitIndex = formatToken.indexOf(':');
            const typeRaw = splitIndex >= 0 ? formatToken.slice(0, splitIndex) : formatToken;
            const precisionRaw = splitIndex >= 0 ? formatToken.slice(splitIndex + 1) : '';
            const type = typeRaw.toLowerCase();

            switch (type) {
                case 'money':
                case 'currency':
                case 'numberfr':
                case 'number_fr': {
                    const numericValue = parseNumericValueForFormat(value);
                    if (!Number.isFinite(numericValue)) {
                        return (value === null || typeof value === 'undefined') ? '' : value;
                    }
                    const options = {};
                    if (precisionRaw) {
                        const digits = parseInt(precisionRaw, 10);
                        if (!Number.isNaN(digits)) {
                            options.minimumFractionDigits = digits;
                            options.maximumFractionDigits = digits;
                        }
                    } else if (Number.isInteger(numericValue)) {
                        options.minimumFractionDigits = 0;
                        options.maximumFractionDigits = 0;
                    } else {
                        options.minimumFractionDigits = 2;
                        options.maximumFractionDigits = 2;
                    }
                    return new Intl.NumberFormat('fr-FR', options).format(numericValue);
                }
                default:
                    return (value === null || typeof value === 'undefined') ? '' : value;
            }
        };

        //permet d'afficher dans les textes des éléments dynamiques : [param_target||nom_param]
        Vue.prototype.replaceBy = (elements) => {
            // le commentaire juste en dessous permet de supprimer une erreur js, donc à ne pas supprimer
            /* eslint-disable no-useless-escape */
            if (!elements.text || elements.text===null || elements.text === "null" || elements.text === false) return "";

            var str = elements.text.match(/(?<=\[\[)([^\[\]]*)(?=\]\])/gim);
            var returnText = elements.text;
            if (Array.isArray(str))
                str.forEach((match) => {
                    if (match.indexOf("||") > 0) {
                        var form = store.getters.listForm(elements.page);
                        var page = store.getters.specificPage(elements.page);
                        var modal = store.getters.modalShowParams({
                            type: "to",
                            val: elements.page,
                        });

                        var def = match.split("||");

                        var deep = def[1].split(' ')
                        switch (def[0]) {
                            case "form":
                                if (form && form.fields) {
                                    var findInArray = form
                                    deep.forEach((el) => {
                                        findInArray = findInArray[el]
                                    })
                                    findInArray = (typeof findInArray === 'undefined') ? "" : findInArray;
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        findInArray
                                    );

                                }
                                break;
                            case "user":

                                findInArray = store.getters.currentUser
                                deep.forEach((el) => {
                                    findInArray = findInArray[el]
                                })
                                findInArray = (typeof findInArray === 'undefined') ? "" : findInArray;
                                returnText = returnText.replace(
                                    "[[" + match + "]]",
                                    findInArray
                                );
                                break;
                            case "frontdatas": {
                                findInArray = store.getters.getFrontDatasForPage(elements.page)
                                if (elements.datas) findInArray = elements.datas;
                                deep.forEach((el) => {
                                    if (findInArray !== null && typeof findInArray !== 'undefined' && typeof findInArray === 'object' && Object.prototype.hasOwnProperty.call(findInArray, el)) {
                                        findInArray = findInArray[el];
                                    } else {
                                        findInArray = "";
                                    }
                                })
                                const formatToken = (def.length > 2) ? def.slice(2).join("||") : null;
                                findInArray = (typeof findInArray === 'undefined' || findInArray === null) ? "" : findInArray;
                                const formattedValue = formatToken ? Vue.prototype.formatOutput({ value: findInArray, format: formatToken }) : findInArray;
                                returnText = returnText.replace(
                                    "[[" + match + "]]",
                                    formattedValue
                                );
                                break;

                            }
                            case "page":
                                if (page) {
                                    findInArray = page
                                    deep.forEach((el) => {
                                        findInArray = findInArray[el]
                                    })
                                    findInArray = (typeof findInArray === 'undefined') ? "" : findInArray;
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        findInArray
                                    );
                                }
                                break;

                            case "routerparam": // params dans le back
                                // si un customparam est paramétré on le prend, sinon c'est le param de la page"
                                var datas = (elements.datas) ? elements.datas : page.params;
                                returnText = returnText.replace(
                                    "[[" + match + "]]",
                                    datas[def[1]]
                                );
                                /*
                                    if (modal && modal.show == true) {
                                        returnText = returnText.replace(
                                            "[[" + match + "]]",
                                            modal.params[def[1]]
                                        );
                                    } else {
                                        returnText = returnText.replace(
                                            "[[" + match + "]]",
                                            router.history.current.params[def[1]]
                                        );
                                    } */
                                break;

                            case "routerquery":
                                if (page && page.embedded) {
                                    const contextQuery = page.querys || {}
                                    returnText = returnText.replace("[[" + match + "]]", contextQuery[def[1]] === undefined ? "" : contextQuery[def[1]])
                                } else if (modal && modal.show == true) {
                                    findInArray = (typeof modal.query[def[1]] === 'undefined' || !modal.query) ? "" : modal.query[def[1]];
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        findInArray
                                    );
                                } else {
                                    findInArray = (typeof router.history.current.query[def[1]] === 'undefined') ? "" : router.history.current.query[def[1]];
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        findInArray
                                    );

                                }

                                break;

                            case "table":
                                if (elements.line) {
                                    findInArray = elements.line
                                    deep.forEach((el) => {
                                        // Une variable table peut viser plusieurs niveaux :
                                        // [[table||nom_table alias]]. Si un niveau n'existe pas,
                                        // on retourne une chaîne vide au lieu de casser le rendu Vue.
                                        if (findInArray !== null && typeof findInArray !== 'undefined' && typeof findInArray === 'object' && Object.prototype.hasOwnProperty.call(findInArray, el)) {
                                            findInArray = findInArray[el]
                                        } else {
                                            findInArray = ""
                                        }
                                    })
                                    findInArray = (typeof findInArray === 'undefined' || findInArray===null || findInArray == "null" || findInArray === false) ? "" : findInArray;
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        findInArray
                                    );
                                }
                                break;

                            case "env":
                                var env = environnement.getEnv()
                                    returnText = returnText.replace(
                                        "[[" + match + "]]",
                                        env[deep[0]]
                                    );
                            break;

                            case 'date':
                                //deep étant la valeur récupéré de la variable
                                //pour la date [[date||date ou timestamp]]
                                var date = "";
                                switch (deep[0]) {
                                    case 'date':
                                        date = Vue.prototype.moment().format('YYYY-MM-DD')
                                        break;

                                    case 'datetime':
                                        date = Vue.prototype.moment().format("YYYY-MM-DD HH:mm:ss")
                                        break;
                                    default:
                                        date = Vue.prototype.moment().format(deep[0])
                                        break;
                                }
                                returnText = returnText.replace(
                                    "[[" + match + "]]",
                                    date
                                );


                                break;
                        }
                    }
                });

            return returnText;
        };

        Vue.prototype.createNewPage = (elements) => {
            Vue.prototype.API({ type: 'post', url: '/newpage', params: elements }).then((resp) => {
                resp.data.forEach((page) => {

                    Vue.prototype.sendInRoute(page)

                })
                elements.callback(resp.data);

            });
        };
        // permet de changer un store à partir du paramétrage otherparams du champ
        Vue.prototype.changeStoreOnField = (elements) => {

            if (!elements.item.otherparams || !Array.isArray(elements.item.otherparams.store) || elements.item.otherparams.store.length == 0) return false;

            elements.item.otherparams.store.forEach((storeParam) => {
                const keys = storeParam.listKeys.split(' ')

                switch (storeParam.type) {

                    case 'user':
                        store.dispatch('updateUser', { keys: keys, value: elements.model })

                        break;
                    case 'form':
                        if (keys.length == 2) {
                            store.dispatch('pushForm', { champ: keys[0], key: keys[1], value: elements.model, page: elements.page })
                        } else {
                            store.dispatch('pushForm', { champ: keys[0], value: elements.model, page: elements.page })
                        }
                        break;
                    case 'page':
                        if (keys.length == 2) {

                            store.dispatch('changeParamPage', { page: elements.page, item: keys[0], key: keys[1], value: elements.model })
                        } else {
                            store.dispatch('changeParamPage', { page: elements.page, item: keys[0], value: elements.model })
                        }

                        break;
                    case 'modal':

                        if (keys.length == 2) {
                            store.dispatch('changeOptionsModal', { modal: { type: 'to', val: elements.page }, type: keys[0], key: keys[1], value: elements.model })
                        } else {
                            store.dispatch('changeOptionsModal', { modal: { type: 'to', val: elements.page }, type: keys[0], value: elements.model })
                        }
                        break;
                }
            })


        }

        //permet de selectionner le composant field adéquate (sert dans arrayTable.vue, RoutingField, et calendarModule)
        Vue.prototype.getFieldComponent = (format) => {

            let component = textfield
            switch (format) {
                case 'textfield':
                case 'number':
                case 'email':
                    component = textfield
                    break;
                case 'conversion':
                    component = conversion
                    break;
                case 'select':
                    component = select
                    break;
                case 'radio':
                    component = radio
                    break;
                case 'switch':
                    component = SwitchC
                    break;
                case 'colorpicker':
                    component = colorpicker
                    break;
                case 'arraytable':
                    component = arraytable
                    break;
                case 'autocomplete':
                    component = autocomplete
                    break;
                case 'datepicker':
                    component = datepicker
                    break;
                case 'datetimepicker':
                    component = datetimepicker
                    break;
                case 'timeonlypicker':
                    component = timeonlypicker
                    break;
                case 'datetimeselect':
                    component = datetimeselect
                    break;
                case 'textarea':
                    component = textarea
                    break;
                case 'fileinput':
                    component = fileinput
                    break;
                case 'texteditor':
                    component = texteditor
                    break;
                case 'encartphoto':
                    component = encartphoto
                    break;
                case 'fieldrecurr':
                    component = fieldrecurr
                    break;
                case 'optionscreator':
                    component = optionscreator
                    break;
                case 'optionsreceptor':
                    component = optionsreceptor
                    break;
                case 'abaque':
                    component = abaque
                    break;                    
                default:
                    component = textfield
                    break;
            }

            return component;
        }

        //permet de récupérer tous les modules d'un template
        Vue.prototype.extractModules = (data) => {
        const modules = [];

        function traverse(items) {
            items.forEach(item => {
            if (item.type === 'module') {
                modules.push(item);
            }

            // si un élément contient un sous-tableau "content", on le parcourt aussi
            if (Array.isArray(item.content)) {
                traverse(item.content);
            }

            });
        }

        traverse(data);
        return modules;
        }




    },
};

export { functions as default, randomKey }
